import React from "react";
import { createRoot } from "react-dom/client";
import AircraftData from "./AircraftData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAircraftData: unknown;
	}
}

export function renderAircraftData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AircraftData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAircraftData = renderAircraftData;
